module.exports = __webpack_public_path__ + "static/media/logo-app.1cbb97e9.gif";